import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { stripeApi } from '../../firebase/functionsService';

// Stripe sender sjåføren hit når en onboarding-lenke er utløpt eller allerede brukt.
// Vi lager en ny lenke og sender videre, så sjåføren ikke må lete etter knappen igjen.
export default function StripeRefresh() {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    stripeApi.getConnectOnboardingUrl()
      .then(({ url }) => { if (!cancelled) window.location.replace(url); })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div style={styles.root}>
      {failed ? (
        <div style={styles.card}>
          <p role="alert" style={styles.error}>Kunne ikke åpne Stripe. Prøv igjen, eller kontakt support.</p>
          <Link to="/driver/earnings" style={styles.link}>Tilbake til inntekter</Link>
        </div>
      ) : (
        <p role="status" style={styles.muted}>Åpner Stripe…</p>
      )}
    </div>
  );
}

const styles = {
  root:  { minHeight: '100vh', background: '#f4f6fa', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  card:  { background: '#fff', borderRadius: 12, padding: 24, maxWidth: 420, boxShadow: '0 1px 8px rgba(0,0,0,0.07)' },
  muted: { fontSize: 14, color: '#999' },
  error: { color: '#c0392b', fontSize: 13, background: '#ffeaea', padding: '8px 12px', borderRadius: 6, marginBottom: 12 },
  link:  { fontSize: 14, color: '#635bff', fontWeight: 600 },
};
